import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";

import { Funcionalidade } from "../../models/Funcionalidade.model";
import { Validation } from "./validation";
import { NgxSpinnerService } from "ngx-spinner";
import { STORAGE_KEY_CURRENT_USER } from "src/app/storageCore/constStorageKeys";
import storageX from "src/app/storageCore/storageX";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import { FuncionalidadeTipo } from "src/app/models/FuncionalidadeTipo.model";
import { Modulo } from "src/app/models/Modulo.model";
import { extractFunctionalityErrorMessage, FUNCTIONALITY_ERROR_MESSAGES } from "src/app/utils/error-handler.util";

@Component({
  selector: "app-create-funcionalidade",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.scss"],
})
export class EditFuncionalidadeComponent implements OnInit {
  public funcionalidadeForm: FormGroup;
  public moduloSelected;
  public funcionalidadeTipoSelected;
  public funcionalidade: Funcionalidade;
  public funcionalidadeId: number;
  public title = "Atualizar Funcionalidade";
  public errorMessage;
  private apiBaseService: ApiBaseService;
  private validation: Validation;
  public types: any = [];
  public modulo: any = [];

  ngOnInit(): void {
    this.funcionalidadeForm = this.formBuilder.group(this.validation.rules());
    this.funcionalidadeId = this.activatedRoute.snapshot.params["id"];
    this.loadFuncionalidade(this.funcionalidadeId);
    this.setup();
  }
  async setup(): Promise<void> {
    const params = {
      size: 100,
      page: 0,
    };
    try {
      this.spinner.show();
      const modulo = await this.apiBaseService.get<any>({
        url: new Modulo()["nomeConsultaApiBase"],
        params,
      });
      this.modulo = modulo["content"];

      const types = await this.apiBaseService.get<any>({
        url: new FuncionalidadeTipo()["nomeConsultaApiBase"],
        params,
      });
      this.types = types["content"];

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }

  public async loadFuncionalidade(id): Promise<void> {
    try {
      this.spinner.show();

      const response = await this.apiBaseService.get<Funcionalidade>({
        url: new Funcionalidade()["nomeConsultaApiBase"] + "/" + id,
      });
      this.funcionalidade = response as Funcionalidade;
      this.fillUserData();

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }
  constructor(
    apiBaseService: ApiBaseService,
    private formBuilder: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute
  ) {
    this.apiBaseService = apiBaseService;
    this.validation = new Validation();
  }
  fillUserData(): void {
    this.moduloSelected = this.funcionalidade.modulo.id;
    this.funcionalidadeTipoSelected = this.funcionalidade.funcionalidadeTipo.id;

    if (this.moduloSelected) {
      this.funcionalidadeForm.controls["modulo"].setValue(this.moduloSelected);
    }
    if (this.funcionalidadeTipoSelected) {
      this.funcionalidadeForm.controls["funcionalidadeTipo"].setValue(
        this.funcionalidadeTipoSelected
      );
    }

    const fields = [
      "nmFuncionalidade",
      "dsFuncionalidade",
      "cdPath",
      "cdFuncionalidade",
      "sgFuncionalidade",
    ];
    fields.forEach((element) => {
      this.funcionalidadeForm.controls[element].setValue(
        this.funcionalidade[element]
      );
    });
  }
  public async submitForm(): Promise<void> {
    this.spinner.show();
    this.errorMessage = null; // Limpa mensagens de erro anteriores
    
    try {
      this.coverterUpperCase(this.funcionalidadeForm);

      const values = this.funcionalidadeForm.value;
      const id = Math.floor(this.funcionalidadeId);
      const post = {
        id,
        ...values,
        funcionalidadeTipo: { id: parseInt(values.funcionalidadeTipo) },
        modulo: { id: parseInt(values.modulo) },
        idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
      };

      await this.apiBaseService.put<Funcionalidade>(
        id,
        new Funcionalidade()["nomeConsultaApiBase"],
        post
      );

      this.spinner.hide();
      this.router.navigate(["/funcionalidade"]);
    } catch (error) {
      this.spinner.hide();
      
      // Extrai mensagem de erro específica usando utilitário
      this.errorMessage = extractFunctionalityErrorMessage(error, FUNCTIONALITY_ERROR_MESSAGES.UPDATE_GENERIC);
      
      console.error('Erro ao editar funcionalidade:', error);
    }
  }

  public coverterUpperCase(funcionalidadeForm: FormGroup) {
    // Lista todos os campos de texto que devem ser convertidos para maiúscula
    const textFields = [
      'nmFuncionalidade',
      'dsFuncionalidade', 
      'cdFuncionalidade',
      'sgFuncionalidade',
      'cdPath'
    ];

    // Converte todos os campos de texto para maiúscula
    textFields.forEach(field => {
      const control = funcionalidadeForm.get(field);
      if (control && control.value && typeof control.value === 'string') {
        control.setValue(control.value.toUpperCase());
      }
    });
  }
}
